/**
 * Development-only driver for the launch page's progress overlay, whose state is
 * otherwise only reachable through the backend launch-api callbacks. Seeds it from
 * a `?progress=<key>` param (keys below) as initial state only — a real launch
 * overwrites it, so this is for inspecting layout, not simulating. NODE_ENV-guarded,
 * so none of it ships.
 */

import { Constants } from "./launch-constants.js";

/**
 * @returns {{text: string, protocol: string|null}|null} Seed values for the
 *   overlay, or null to leave it hidden (always null in production).
 */
export const getDevProgressState = () => {
    if (process.env.NODE_ENV === "development") {
        const states = {
            default: { text: Constants.DefaultProgressText, protocol: null },
            parallels: {
                text: Constants.ProgressText.ParallelsClient,
                protocol: Constants.Protocols.ParallelsClient,
            },
            dcv: { text: Constants.ProgressText.DcvClientHandler, protocol: null },
            browser: { text: Constants.ProgressText.Browser, protocol: null },
            file: {
                text: Constants.ProgressText.getFileProgressText("bba.dcv"),
                protocol: null,
            },
        };
        return states[new URLSearchParams(window.location.search).get("progress")] ?? null;
    }
    return null;
};
